import { evidenceSidebarOpenAtom } from '@/atoms/evidenceSidebarAtoms';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

/**
 * Returns a stable callback that opens the in-session Evidence / Ask Heidi
 * chat panel on the right-hand expandable sidebar.
 */
export const useOpenEvidencePanel = () => {
  const setEvidenceSidebarOpen = useSetAtom(evidenceSidebarOpenAtom);

  return useCallback(() => {
    setEvidenceSidebarOpen(true);
  }, [setEvidenceSidebarOpen]);
};
